import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import ReactButton from 'components/Buttons/ReactButton';
import AssessmentService from '../service';
import { Form, Input } from 'reactstrap';
import { toast } from 'react-toastify';

export default function FeedbackForm({ onSave, assessmentId }) {
  const { control, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    const dataDTO = {
      ...data,
      assessmentId
    };

    try {
      await AssessmentService.postAssessmentFeedback(dataDTO)
        .then((response) => {
          toast.success('Feedback enviado com sucesso');
          if (onSave) onSave(response.data.data);
        })
        .catch((err) =>
          toast.error(
            err.response?.data.errors[0] ||
              err.response?.data.message ||
              `Erro ao enviar feedback`
          )
        );
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} noValidate>
      <h4>Descrição:</h4>
      <Controller
        render={(props) => (
          <Input
            value={props.value}
            onChange={props.onChange}
            type="textarea"
            style={{ height: '92px', marginBottom: '20px' }}
            placeholder="Escreva seu feedback..."
          />
        )}
        control={control}
        defaultValue={''}
        name="description"
      />

      <ReactButton type="submit" btnColor="confirmation">
        Salvar Feedback
      </ReactButton>
    </Form>
  );
}
